import { CircleArrowLeft } from "lucide-react";

const ArrowBack = ({ onClick }) => {
    return (
        <CircleArrowLeft
            className="w-4 h-4"
            onClick={onClick ? () => {
                onClick();
            } : undefined}
        />
    );
}

export default ArrowBack;